export default {"src":"/_next/static/media/logo-alt.cb8057b6.svg","height":118,"width":205,"blurWidth":0,"blurHeight":0};